import { useCarousel } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { borderCardSize, SocialPost, type SocialPostProps } from "../social-post/SocialPost";

interface ILazySocialPostProps extends SocialPostProps {
    index: number;
}

export const LazySocialPost = ({ index, ...postProps }: ILazySocialPostProps) => {
    const { slidesInView } = useCarousel();
    const isInView = slidesInView.includes(index);

    if (!isInView) {
        return (
            <Box
                height={`${borderCardSize.height}px`}
                width={`${borderCardSize.width}px`}
            />
        );
    }

    return <SocialPost {...postProps} />;
};
